<template>
  <div>
    <b-tooltip :target="target" :placement="placement">
      <slot></slot>
    </b-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UeTooltip',
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      required: false,
    },
  },
})
</script>
